export const gray600 = '#6B6B6B';

export const blue500 = '#2374BB';
export const primaryBlue = blue500;

export const green700 = '#2e7d32';

export const gray100 = '#f5f5f5';
export const gray300 = '#dddddd';
export const gray800 = '#333333';

export const blueGreen200 = '#2374bb';

export const orange700 = '#ff961d';
